import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

// 로그인이 필요한 라우트를 감싸는 가드.
// - checked === false: /auth/me 응답 대기 중 → 잠깐 로딩 표시
// - checked === true && userPk 없음: 비로그인 → /login 으로 리다이렉트
// - checked === true && userPk 있음: 자식 라우트 렌더
export default function ProtectedRoute() {
  const { checked, userPk } = useSelector((state) => state.loginSlice);

  if (!checked) {
    return (
      <div className="w-full h-[100dvh] flex items-center justify-center bg-gradient-to-b from-slate-900 via-blue-900 to-cyan-700 bg-fixed">
        <p className="text-sm text-white/70">로그인 확인 중...</p>
      </div>
    );
  }

  if (!userPk) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
